import { ResourceMapperNotificationTypes } from '../types';
import i18n from 'i18next';

export const generateMappingMessage = (
  successes: any[],
  startingDescription: string,
  endingDescription: string,
  referenceId: string,
  no_undo: boolean = false,
) => {
  let note_type = ResourceMapperNotificationTypes.PATCH_SUCCESS;
  const note = {
    message: i18n.t('resource_mapper.notifications.mapped_to', {
      startingDescription,
      endingDescription,
    }),
    description: i18n.t('resource_mapper.notifications.instances_mapped_message', {
      count: successes.length,
    }),
    type: `SUCCESS${no_undo ? '_NO_UNDO' : ''}`,
    referenceId,
  };
  if (!successes.length) {
    note_type = ResourceMapperNotificationTypes.PATCH_FAIL;
  }

  if (note.type === 'SUCCESS_NO_UNDO') {
    note.message = i18n.t('resource_mapper.notifications.undo_successful');
    note.description = i18n.t('resource_mapper.notifications.has_been_undone_from', {
      startingDescription,
      endingDescription,
    });
  }
  return { note_type, note };
};
